import http from "../utils/http"

/**
 * 图片上传
 * @param {FormData} formData 包含文件的表单数据
 */
export function uploadImage(formData) {
    return http({
        url: "/api/upload/image",
        method: "POST",
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

/**
 * 上传转账凭证
 * @param {FormData} formData 包含文件的表单数据
 */
export function uploadVoucher(formData) {
    return http({
        url: "/api/upload/image",
        method: "POST", 
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}